<template>
  <aside class="sidebar">
    <!-- Brand -->
    <div class="sidebar-brand">
      <div class="brand-mark">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 12L12 4l8 8-8 8-8-8z" fill="currentColor" opacity="0.9" />
          <path d="M12 8.5L15.5 12 12 15.5 8.5 12 12 8.5z" fill="#ffffff" />
        </svg>
      </div>
    </div>

    <!-- Primary nav -->
    <nav class="sidebar-nav">
      <ul class="nav-list">
        <!-- 1. Dashboard (leaf) -->
       <li class="nav-item">
  <router-link
    :to="{ name: 'Dashboard' }"
    class="nav-link"
    active-class="is-active"
    @click="closeMenu"
  >
    <span class="active-indicator"></span>

    <span class="nav-icon">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="3.5" y="3.5" width="7" height="7" rx="1.6" />
        <rect x="13.5" y="3.5" width="7" height="7" rx="1.6" />
        <rect x="3.5" y="13.5" width="7" height="7" rx="1.6" />
        <rect x="13.5" y="13.5" width="7" height="7" rx="1.6" />
      </svg>
    </span>

    <span class="tooltip">Dashboard</span>
    <span class="mobile-label">Dashboard</span>
  </router-link>
</li>
        <!-- 4. Suppliers (has submenu) -->
        <li class="nav-item has-submenu" @mouseenter="openMenu('suppliers', $event)" @mouseleave="scheduleClose">
          <button type="button" class="nav-link" :class="{ 'is-active': activeKey === 'suppliers' }"
            @click="handleParentClick('suppliers', $event)">
            <span class="active-indicator" :class="{ show: activeKey === 'suppliers' }"></span>
            <span class="nav-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                stroke-linejoin="round">
                <path d="M3 16V6a1 1 0 0 1 1-1h9v11" />
                <path d="M13 9h4l4 4v3h-8" />
                <circle cx="7.5" cy="17.5" r="1.8" />
                <circle cx="17" cy="17.5" r="1.8" />
              </svg>
            </span>
            <span class="mobile-label">Suppliers</span>
          </button>

          <!-- Submenu inside the li -->
          <transition name="popup-fade">
            <div v-if="openKey === 'suppliers'" class="submenu-popup" :style="popupStyle" @mouseenter="keepOpen"
              @mouseleave="scheduleClose">
              <div class="popup-arrow"></div>
              <div class="popup-header">
                <span class="popup-title">Suppliers</span>
              </div>
              <ul class="popup-list">
                <li>
                 <router-link :to="{ name: 'SupplierList' }" class="popup-link" active-class="is-active" @click="closeMenu">
                  <span class="popup-link-dot"></span>All Suppliers
                </router-link>
                </li>
                <li>
                 <router-link :to="{ name: 'AllReviews' }" class="popup-link"
                    :class="{ 'is-active': $route.name === 'AllReviews' }" @click="closeMenu">
                    <span class="popup-link-dot"></span>
                    Reviews
                  </router-link>
                </li>
              </ul>
            </div>
          </transition>
        </li>
        <!-- 7. Settings (has submenu) -->
        <!-- <li class="nav-item has-submenu" @mouseenter="openMenu('settings', $event)" @mouseleave="scheduleClose">
          <button type="button" class="nav-link" :class="{ 'is-active': activeKey === 'settings' }"
            @click="handleParentClick('settings', $event)">
            <span class="active-indicator" :class="{ show: activeKey === 'settings' }"></span>
            <span class="nav-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="3.2" />
                <path
                  d="M19.4 13.6a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.04 1.56V19.5a2 2 0 1 1-4 0v-.09A1.7 1.7 0 0 0 8.96 17.85a1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.7 1.7 0 0 0 .34-1.87A1.7 1.7 0 0 0 3 12.55h-.09a2 2 0 1 1 0-4H3A1.7 1.7 0 0 0 4.6 7.51a1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 8.96 3.15 1.7 1.7 0 0 0 10 1.6V1.5a2 2 0 1 1 4 0v.09a1.7 1.7 0 0 0 1.04 1.56 1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.7 1.7 0 0 0-.34 1.87c.27.62.86 1.04 1.56 1.04H21a2 2 0 1 1 0 4h-.09a1.7 1.7 0 0 0-1.56 1.04z" />
              </svg>
            </span>
            <span class="mobile-label">Settings</span>
          </button>
          <transition name="popup-fade">
            <div v-if="openKey === 'settings'" class="submenu-popup" :style="popupStyle" @mouseenter="keepOpen"
              @mouseleave="scheduleClose">
              <div class="popup-arrow"></div>
              <div class="popup-header">
                <span class="popup-title">Settings</span>
              </div>
              <ul class="popup-list">
                <li>
                  <a href="#" class="popup-link"
                    :class="{ 'is-active': activeKey === 'settings' && activeChild === 'General' }"
                    @click.prevent="setChild('settings', 'General')">
                    <span class="popup-link-dot"></span>General
                  </a>
                </li>
                <li>
                  <a href="#" class="popup-link"
                    :class="{ 'is-active': activeKey === 'settings' && activeChild === 'Team Members' }"
                    @click.prevent="setChild('settings', 'Team Members')">
                    <span class="popup-link-dot"></span>Team Members
                  </a>
                </li>
                <li>
                  <a href="#" class="popup-link"
                    :class="{ 'is-active': activeKey === 'settings' && activeChild === 'Billing' }"
                    @click.prevent="setChild('settings', 'Billing')">
                    <span class="popup-link-dot"></span>Billing
                  </a>
                </li>
              </ul>
            </div>
          </transition>
        </li> -->
      </ul>
    </nav>
    <!-- Footer / profile -->
<div class="sidebar-footer" @mouseenter="openMenu('profile', $event)" @mouseleave="scheduleClose">
  <button type="button" class="nav-link footer-link" @click="handleParentClick('profile', $event)">

    <span class="avatar">
      {{ adminInitials }}
    </span>

    <span class="tooltip" v-if="openKey !== 'profile'">
      {{ adminFullName }}
      <br />
      <small>{{ admin.email }}</small>
    </span>

    <span class="mobile-label">
      {{ adminFullName }}
    </span>

  </button>

  <!-- Profile / logout popup -->
  <transition name="popup-fade">
    <div v-if="openKey === 'profile'" class="submenu-popup profile-popup" :style="popupStyle"
      @mouseenter="keepOpen" @mouseleave="scheduleClose">
      <div class="popup-arrow"></div>
      <ul class="popup-list">
        <li>
          <button type="button" class="popup-link popup-link--danger" @click="adminlogout">
            <span class="popup-link-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
            </span>
            Logout
          </button>
        </li>
      </ul>
    </div>
  </transition>
</div>

    <!-- Mobile backdrop -->
    <transition name="backdrop-fade">
      <div v-if="openKey" class="popup-backdrop" @click="closeMenu"></div>
    </transition>
  </aside>
</template>
<script>
export default {
  name: 'SidebarNavigation',

  data() {
    return {
      activeKey: 'dashboard',
      activeChild: null,
      openKey: null,
      popupStyle: {},
      closeTimer: null,
      supportsHover: window.matchMedia('(hover: hover)').matches,

      admin: {
        id: '',
        external_id: '',
        first_name: '',
        last_name: '',
        email: ''
      }
    }
  },

  computed: {
    adminFullName() {
      const name = `${this.admin.first_name} ${this.admin.last_name}`.trim()
      return name || 'Admin'
    },
    adminInitials() {
      const first = this.admin.first_name?.charAt(0) || ''
      const last = this.admin.last_name?.charAt(0) || ''
      return `${first}${last}`.toUpperCase() || 'AD'
    }
  },

  mounted() {
    this.loadAdmin()
  },

  methods: {
    loadAdmin() {
      this.admin = {
        id: localStorage.getItem('admin_id') || '',
        external_id: localStorage.getItem('admin_external_id') || '',
        first_name: localStorage.getItem('admin_first_name') || '',
        last_name: localStorage.getItem('admin_last_name') || '',
        email: localStorage.getItem('admin_email') || ''
      }
    },
    openMenu(key, event) {
      if (!this.supportsHover) return
      this.positionAndOpen(key, event)
    },
    positionAndOpen(key, event) {
      clearTimeout(this.closeTimer)

      const rect = event.currentTarget.getBoundingClientRect()
      const isMobile = window.innerWidth <= 640

      if (isMobile) {
        this.popupStyle = {
          left: '12px',
          right: '12px',
          bottom: `${window.innerHeight - rect.top + 12}px`
        }
      } else {
        this.popupStyle = {
          top: `${rect.top}px`,
          left: `${rect.right + 14}px`
        }
      }

      this.openKey = key
    },

    keepOpen() {
      if (!this.supportsHover) return
      clearTimeout(this.closeTimer)
    },

    scheduleClose() {
      if (!this.supportsHover) return
      this.closeTimer = setTimeout(() => {
        this.openKey = null
      }, 180)
    },

    closeMenu() {
      clearTimeout(this.closeTimer)
      this.openKey = null
    },
    handleParentClick(key, event) {
      this.setActive(key)

      if (this.openKey === key) {
        this.closeMenu()
      } else {
        this.positionAndOpen(key, event)
      }
    },

    setActive(key) {
      this.activeKey = key
      this.activeChild = null
    },

    setChild(parentKey, child) {
      this.activeKey = parentKey
      this.activeChild = child
      this.openKey = null
    },
     adminlogout() {
    this.closeMenu()
    localStorage.removeItem('admin_token')
    localStorage.removeItem('admin_id')
    localStorage.removeItem('admin_external_id')
    localStorage.removeItem('admin_first_name')
    localStorage.removeItem('admin_last_name')
    localStorage.removeItem('admin_email')

    this.$router.push({ name: 'AdminLogin' }) 
  },
  }
}
</script>
<style scoped>
.sidebar {
  position: relative;
  height: 100vh;
  width: 84px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--color-surface);
  border-right: 1px solid var(--color-border);
  padding: 22px 0 18px;
  box-shadow: 2px 0 18px rgba(93, 28, 106, 0.05);
  font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  transition: width 0.2s ease, height 0.2s ease, padding 0.2s ease;
}

.sidebar * {
  box-sizing: border-box;
}

.sidebar-brand {
  margin-bottom: 28px;
}

.brand-mark {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-surface);
  background: linear-gradient(145deg, var(--color-primary), var(--color-secondary));
  box-shadow: 0 4px 10px rgba(93, 28, 106, 0.28);
}

.brand-mark svg {
  width: 22px;
  height: 22px;
}

.sidebar-nav {
  flex: 1;
  width: 100%;
  overflow-y: auto;
  overflow-x: visible;
  scrollbar-width: none;
}

.sidebar-nav::-webkit-scrollbar {
  display: none;
}

.nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.nav-item {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
}

.nav-link {
  position: relative;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  border-radius: 14px;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: background 0.22s ease, color 0.22s ease, transform 0.18s ease,
    box-shadow 0.22s ease, width 0.2s ease, height 0.2s ease;
}

.nav-link:hover {
  background: var(--color-tint-light);
  color: var(--color-secondary);
  transform: translateY(-1px);
}

.nav-link:active {
  transform: translateY(0) scale(0.96);
}

.nav-link.is-active {
  background: linear-gradient(145deg, var(--color-tint-light), #ffe3e0);
  color: var(--color-primary);
  box-shadow: 0 6px 14px -4px rgba(93, 28, 106, 0.35);
}

.nav-icon {
  width: 21px;
  height: 21px;
  display: inline-flex;
  transition: color 0.22s ease, transform 0.22s ease;
}

.nav-icon svg {
  width: 100%;
  height: 100%;
}

.nav-link:hover .nav-icon {
  transform: scale(1.06);
}

/* Active indicator */
.active-indicator {
  position: absolute;
  left: -14px;
  top: 50%;
  transform: translateY(-50%) scaleY(0);
  width: 4px;
  height: 22px;
  border-radius: 0 4px 4px 0;
  background: linear-gradient(180deg, var(--color-primary), var(--color-secondary));
  opacity: 0;
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.active-indicator.show {
  opacity: 1;
  transform: translateY(-50%) scaleY(1);
}

.mobile-label {
  display: none;
}

/* ==========================================================================
   3. Tooltips
   ========================================================================== */
.tooltip {
    position: absolute;
    left: calc(100% + 14px);
    top: 50%;
    transform: translateY(-50%) translateX(-6px);

    white-space: nowrap;

    background: var(--color-text-dark);
    color: #fdf3f6;

    font-size: 12.5px;
    font-weight: 500;
    line-height: 1.4;

    padding: 7px 12px;
    border-radius: 8px;

    box-shadow: 0 8px 20px rgba(52, 19, 60, 0.3);

    opacity: 0;
    pointer-events: none;
    visibility: hidden;

    transition:
        opacity 0.18s ease,
        transform 0.18s ease,
        visibility 0.18s;

    z-index: 99999;
}

.footer-link:hover .tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateY(-50%) translateX(0);
}

.tooltip small {
  display: block;
  font-weight: 400;
  opacity: 0.7;
  font-size: 11px;
  margin-top: 1px;
}

.nav-item:not(.has-submenu) .nav-link:hover .tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateY(-50%) translateX(0);
}

.footer-link:hover .tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateY(-50%) translateX(0);
}

/* ==========================================================================
   4. Footer / profile
   ========================================================================== */
.sidebar-footer {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 14px;
  border-top: 1px solid var(--color-border);
  margin-top: 10px;
}

.footer-link {
  border-radius: 50%;
  width: 44px;
  height: 44px;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(145deg, var(--color-secondary), var(--color-tint-warm));
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
  box-shadow: 0 4px 10px rgba(202, 89, 149, 0.4);
}

.submenu-popup {
  position: fixed;
  min-width: 220px;
  background: var(--color-surface);
  border-radius: 18px;
  padding: 12px;
  box-shadow: 0 20px 45px -12px rgba(93, 28, 106, 0.28), 0 6px 16px rgba(93, 28, 106, 0.1);
  border: 1px solid var(--color-border);
  z-index: 60;
}

.popup-arrow {
  position: absolute;
  left: -6px;
  top: 22px;
  width: 12px;
  height: 12px;
  background: var(--color-surface);
  border-left: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
  transform: rotate(45deg);
  border-radius: 3px;
}

.popup-header {
  padding: 6px 10px 10px;
  margin-bottom: 4px;
  border-bottom: 1px solid var(--color-border);
}

.popup-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-dark);
}

.popup-list {
  list-style: none;
  margin: 4px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.popup-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #7a6b7e;
  font-size: 13.5px;
  font-weight: 500;
  padding: 9px 12px;
  border-radius: 10px;
  transition: background 0.18s ease, color 0.18s ease, padding-left 0.18s ease;
}

.popup-link-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #e6d7de;
  transition: background 0.18s ease, transform 0.18s ease;
  flex-shrink: 0;
}

.popup-link:hover {
  background: var(--color-tint-light);
  color: var(--color-secondary);
  padding-left: 15px;
}

.popup-link:hover .popup-link-dot {
  background: var(--color-secondary);
  transform: scale(1.3);
}

.popup-link.is-active {
  background: linear-gradient(145deg, var(--color-tint-light), #ffe3e0);
  color: var(--color-primary);
  font-weight: 600;
}

.popup-link.is-active .popup-link-dot {
  background: var(--color-primary);
}

/* Popup transition */
.popup-fade-enter-active {
  transition: opacity 0.18s ease, transform 0.2s cubic-bezier(0.25, 1, 0.5, 1);
}

.popup-fade-leave-active {
  transition: opacity 0.14s ease, transform 0.14s ease;
}

.popup-fade-enter-from {
  opacity: 0;
  transform: translateX(-8px) scale(0.97);
}

.popup-fade-leave-to {
  opacity: 0;
  transform: translateX(-6px) scale(0.98);
}

.popup-backdrop {
  position: fixed;
  inset: 0;
  background: transparent;
  z-index: 45;
  display: none;
}

.backdrop-fade-enter-active,
.backdrop-fade-leave-active {
  transition: opacity 0.15s ease;
}

.backdrop-fade-enter-from,
.backdrop-fade-leave-to {
  opacity: 0;
}

@media (min-width: 641px) and (max-width: 1024px) {
  .sidebar {
    width: 72px;
    padding: 18px 0 16px;
  }

  .nav-link {
    width: 44px;
    height: 44px;
  }

  .submenu-popup {
    min-width: 208px;
  }
}

/* ==========================================================================
   7. Responsive — mobile
   ========================================================================== */
@media (max-width: 640px) {
  .sidebar {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 68px;
    flex-direction: row;
    align-items: center;
    padding: 6px 8px;
    border-right: none;
    border-top: 1px solid var(--color-border);
    box-shadow: 0 -6px 20px rgba(93, 28, 106, 0.08);
    z-index: 50;
  }

  .sidebar-brand {
    display: none;
  }

  .sidebar-nav {
    flex: 1;
    width: auto;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .nav-list {
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    gap: 2px;
    min-width: max-content;
    width: 100%;
  }

  .nav-item {
    width: auto;
  }

  .nav-link {
    width: 54px;
    height: 52px;
    flex-direction: column;
    gap: 3px;
    border-radius: 12px;
  }

  .nav-icon {
    width: 19px;
    height: 19px;
  }

  .tooltip {
    display: none;
  }

  .mobile-label {
    display: block;
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
  }

  .active-indicator {
    left: 50%;
    top: -4px;
    bottom: auto;
    width: 20px;
    height: 3px;
    border-radius: 0 0 4px 4px;
    transform: translateX(-50%) scaleX(0);
  }

  .active-indicator.show {
    transform: translateX(-50%) scaleX(1);
  }

  .sidebar-footer {
    width: auto;
    border-top: none;
    margin-top: 0;
    padding-top: 0;
    padding-left: 6px;
    border-left: 1px solid var(--color-border);
  }

  .footer-link {
    width: 52px;
    height: 52px;
  }

  .submenu-popup {
    border-radius: 18px 18px 16px 16px;
  }

  .popup-arrow {
    display: none;
  }

  .popup-backdrop {
    display: block;
  }
}
.profile-popup {
  min-width: 220px;
}

.popup-subtitle {
  display: block;
  font-size: 11.5px;
  color: var(--color-text-muted);
  font-weight: 400;
  margin-top: 2px;
}

.popup-link--danger {
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #b3261e;
  font-family: inherit;
  text-align: left;
}

.popup-link--danger:hover {
  background: rgba(179, 38, 30, 0.08);
  color: #b3261e;
}

.popup-link--danger .popup-link-icon {
  width: 16px;
  height: 16px;
  display: inline-flex;
  flex-shrink: 0;
}

.popup-link--danger .popup-link-icon svg {
  width: 100%;
  height: 100%;
}
</style>